import { concat, unionBy } from "lodash";
import { adminPanelOptionConfigRegistryType, adminPanelOptionRegistryKeyValue } from "../../components/adminPanelLayout/adminPanelTypes";
import { AllSidebarOptions } from "../../configurations/allSidebarOptions";
import { adminPanelOptionConfigRegistry } from "../adminPanel/AdminPanel";
import { defaultFooterOptions } from "../footerConfiguration/FooterConfiguration";
import { defaultMoreOptions } from "../moreOptionsConfiguration/MoreOptionsConfiguration";


export const defaultRoleMapping: { [key: string]: string[]; } = {
    role1:['Order','Recommendation',"Offers"],
    role2:["Order","dsAbsent"],
}
export interface featureType{
    name:string,
    displayName:string,
    version:string,
    template:string,
    default?: boolean
}
export type roleAccessOptionsTypes= 'app'|'portal'
export type roleType = "retailer" | "salesrep" | "admin" | "reportadmin" | "other" | "supplier";
export type roleAccessMapping = {
    [key:string]: {
        accessType: roleAccessOptionsTypes,
        uiConfigFeatures: string[]
    }
}
export const portalDashboardFeatureRegistry :featureType[] = AllSidebarOptions.map(sidebarOption=>({
    name:sidebarOption.id,
    displayName: sidebarOption?.newLabel ?? sidebarOption?.label,
    version:'1.0',
    template:'mainDashboard',
}))

export const portalAdminFeatureRegistry : featureType[] = Object.keys(adminPanelOptionConfigRegistry).map((adminPanelOptionId: string) => {
    const adminPanelOptionObj = adminPanelOptionConfigRegistry[adminPanelOptionId];
    return {
        name: adminPanelOptionId,
        displayName: adminPanelOptionObj.label,
        version: '1.0',
        template: 'adminPanel'
    }
})
export const portalFeatureRegistry :featureType[]  = [...portalDashboardFeatureRegistry,...portalAdminFeatureRegistry];

export const bothFeatureRegistry :featureType[]=[
    {
        name:'order',
        displayName:'Order',
        version:'1.0',
        template:'',
    },
    {
        name:'secondaryproduct',
        displayName:'Secondary Product',
        version:'1.0',
        template:'',
    },
    {
        name:'banner',
        displayName:'Banner',
        version:'1.0',
        template:'',
    },
    {
        name:'recommendation',
        displayName:'Recommendation',
        version:'1.0',
        template:'',
    },
    {
        name:'offers',
        displayName:'Offers',
        version:'1.0',
        template:'',
    },
    {
        name:'faq',
        displayName:'FAQ',
        version:'1.0',
        template:'',
    },
    {
        name:'favouriteskus',
        displayName:'Favouriteskus',
        version:'1.0',
        template:'',
    },
    {
        name:'notification',
        displayName:'Notification',
        version:'1.0',
        template:'',
    },
    {
        name:'helpdesk',
        displayName:'Helpdesk',
        version:'1.0',
        template:'',
    },
    {
        name:'customer service',
        displayName:'Customer Service',
        version:'1.0',
        template:'',
    },
    {
        name:'bank enrolment',
        displayName:'Bank Enrolment',
        version:'1.0',
        template:'',
    },
    {
        name:'billing',
        displayName:'Billing',
        version:'1.0',
        template:'',
    },
    {
        name:'about',
        displayName:'About',
        version:'1.0',
        template:'',
    },
    {
        name:'more',
        displayName:'More',
        version:'1.0',
        template:'',
    },
    {
        name:'change password',
        displayName:'Change Password',
        version:'1.0',
        template:'',
    },
    ...portalFeatureRegistry
]

// export const portalFeatureRegistry :featureType[]=[
//     {
//         name:'order',
//         displayName:'Order',
//         version:'1.0',
//         template:'',
//     },
//     {
//         name:'banner',
//         displayName:'Banner',
//         version:'1.0',
//         template:'',
//     }
// ]


export const appFeatureRegistry :featureType[]=[
    {
        name:'order',
        displayName:'Order',
        version:'1.0',
        template:'',
    },
    {
        name:'secondaryproduct',
        displayName:'Secondary Product',
        version:'1.0',
        template:'',
    },
    {
        name:'banner',
        displayName:'Banner',
        version:'1.0',
        template:'',
    },
    {
        name:'recommendation',
        displayName:'Recommendation',
        version:'1.0',
        template:'',
    },
    {
        name:'offers',
        displayName:'Offers',
        version:'1.0',
        template:'',
    },
    {
        name:'faq',
        displayName:'FAQ',
        version:'1.0',
        template:'',
    },
    {
        name:'favouriteskus',
        displayName:'Favouriteskus',
        version:'1.0',
        template:'',
    },
    {
        name:'notification',
        displayName:'Notification',
        version:'1.0',
        template:'',
    },
    {
        name:'helpdesk',
        displayName:'Helpdesk',
        version:'1.0',
        template:'',
    },
    {
        name:'customer service',
        displayName:'Customer Service',
        version:'1.0',
        template:'',
    },
    {
        name:'bank enrolment',
        displayName:'Bank Enrolment',
        version:'1.0',
        template:'',
    },
    {
        name:'billing',
        displayName:'Billing',
        version:'1.0',
        template:'',
    },
    {
        name:'about',
        displayName:'About',
        version:'1.0',
        template:'',
    },
    {
        name:'more',
        displayName:'More',
        version:'1.0',
        template:'',
    },
    {
        name:'change password',
        displayName:'Change Password',
        version:'1.0',
        template:'',
    },
    {
        name:'dsAbsent',
        displayName:'dsAbsent',
        version:'1.0',
        template:'',
    },

]

export const defaultAppLayoutConfig = [
    {
        "name": "homePageWidget",
        "type": "widgetLayout",
        "value": [],
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "home page layout config",
        "defaultValue": null,
        "possibleVals": [
          "widgetLayout",
          "formLayout",
          "reportLayout"
        ]
      },
      {
        "name": "bottomBarLayout",
        "type": "List",
        "value": [...defaultFooterOptions.bottomBarLayout.value],
        "docUrl": "",
        "description": "footer options layout config",
        "defaultValue": null,
      },
      {
        "name": "morePageWidget",
        "type": "widgetLayout",
        "value": [...defaultMoreOptions.morePageWidget.value],
        "docUrl": "",
        "description": "more page layout config",
        "defaultValue": null,
      },
]
export type roleRegistry = {
    [key in roleAccessOptionsTypes]: accessTypeMapping
}
type accessTypeMapping = {
    [key in roleType]?: featureType[]
}
export const manageRoleRegistry: roleRegistry = {
    app: {
      retailer: [
          {
              name:'about',
              displayName:'About',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name: "support",
              displayName: "Support",
              version: '1.0',
              template:'',
              default: true
          },
          {
              name:'banner',
              displayName:'Banner',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'outlets',
              displayName:'Outlets',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'supplier',
              displayName:'Supplier',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'products',
              displayName:'Products',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'helpdesk',
              displayName:'Helpdesk',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'order',
              displayName:'Order',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'productfilter',
              displayName:'Product Filter',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'faq',
              displayName:'FAQ',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'profile',
              displayName:'Profile',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'more',
              displayName:'More',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'notification',
              displayName:'Notification',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'recommendation',
              displayName:'Recommendation',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'secondaryproduct',
              displayName:'Secondary Product',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'offers',
              displayName:'Offers',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'favouriteskus',
              displayName:'Favouriteskus',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'dashboard',
              displayName:'Dashboard',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'loyalty',
              displayName:'Loyalty',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'customerservice',
              displayName:'Customer Service',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'invoices',
              displayName:'Invoices',
              version:'1.0',
              template:'',
              default: false
          }
      ],
      salesrep: [
          {
              name:'about',
              displayName:'About',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name: "support",
              displayName: "Support",
              version: '1.0',
              template:'',
              default: true
          },
          {
              name:'banner',
              displayName:'Banner',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'outlets',
              displayName:'Outlets',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'supplier',
              displayName:'Supplier',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'products',
              displayName:'Products',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'helpdesk',
              displayName:'Helpdesk',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'order',
              displayName:'Order',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'productfilter',
              displayName:'Product Filter',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'faq',
              displayName:'FAQ',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'profile',
              displayName:'Profile',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'more',
              displayName:'More',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'notification',
              displayName:'Notification',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'recommendation',
              displayName:'Recommendation',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'secondaryproduct',
              displayName:'Secondary Product',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'offers',
              displayName:'Offers',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'outletmapping',
              displayName:'Outlet Mapping',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'storeInOut',
              displayName:'Store-In-Out',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'attendence',
              displayName:'Attendence',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'competitionTracking',
              displayName:'Competition Tracking',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'outletProfile',
              displayName:'Outlet Profile',
              version:'1.0',
              template:'',
              default: true
          },
          {
              name:'inventory',
              displayName:'Inventory',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'remoteOrder',
              displayName:'Remote Order',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'teleOrder',
              displayName:'TeleOrder',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'kpi',
              displayName:'KPI',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'mustDoAction',
              displayName:'Must Do Action',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'orderFeedback',
              displayName:'Order Feedback',
              version:'1.0',
              template:'',
              default: false
          },
          {
              name:'outletOnboardingDashboard',
              displayName:'Outlet Onboarding Dashboard',
              version:'1.0',
              template:'',
              default: false
          }
      ]
    },
    portal: {
        reportadmin: [
            {
                name: "manageHomeScreen",
                displayName: "Manage HomeScreen",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },
            {
                name: "userAnalytics",
                displayName: "User Analytics",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },
            {
                name: "googleAnalytics",
                displayName: "Google Analytics",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },
            {
                name: "mdm",
                displayName: "MDM",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },
            {
                name: "notification",
                displayName: "Notification",
                version:'1.0',
                template: "adminPanel",
                default: false
            },
            {
                name: "support",
                displayName: "Support",
                version:'1.0',
                template: "adminPanel",
                default: false
            },
            {
                name: "uiConfig",
                displayName: "UI Config",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },
            {
                name: "buisnessImapact",
                displayName: "Buisness Impact",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },{
                name: "orderAnalytics",
                displayName: "Order Analytics",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },
            {
                name: "reports",
                displayName: "Reports",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },
            {
                name: "managePolicies",
                displayName: "Manage Policies",
                version:'1.0',
                template: "adminPanel",
                default: false
            },
            {
                name: "manageBanner",
                displayName: "Manage Banner",
                version:'1.0',
                template: "adminPanel",
                default: false
            },
            {
                name: "edaQuantityCompliance",
                displayName: "EDA Quantity Compliance",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },
            {
                name: "skuSelectionCompliance",
                displayName: "EDA SKU Selection Compliance",
                version:'1.0',
                template: "mainDashboard",
                default: false
            }
        ],
        supplier: [
            {
                name: "buisnessImapact",
                displayName: "Buisness Impact",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },{
                name: "orderAnalytics",
                displayName: "Order Analytics",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },
            {
                name: "reports",
                displayName: "Reports",
                version:'1.0',
                template: "mainDashboard",
                default: false
            },
        ]
    }
  }
  manageRoleRegistry.app.other = unionBy(manageRoleRegistry.app.retailer,manageRoleRegistry.app.salesrep,"name").map((registryObj) => {
    return {
        ...registryObj,
        default: false
    }
  });
  manageRoleRegistry.portal.other = portalFeatureRegistry;
  manageRoleRegistry.portal.reportadmin = portalFeatureRegistry;
  manageRoleRegistry.portal.supplier = portalFeatureRegistry;